export default __webpack_public_path__ + "static/media/user-profiles.2bba6f22.svg";